import { memo } from 'react'
import { FolderClosed } from 'almanac-ui/icons'

export const DefaultFolderEmoji = memo(({ className }: { className?: string }) => {
  return <FolderClosed className={className} />
})
